window.CustomShippingBar = (() => {
  // --- CURRENCY SETUP ---
  const detectCurrency = () => {
    if (window.Shopify?.currency?.active) return Shopify.currency.active;
    const meta = document.querySelector('meta[name="shop-currency"]');
    if (meta) return meta.getAttribute('content');
    return 'EUR';
  };

  const currencyCode = detectCurrency();
  const currencySymbol = {
    EUR: '€',
    GBP: '£',
    USD: '$',
    CAD: '$',
    AUD: '$',
    NZD: '$',
  }[currencyCode] || currencyCode + ' ';

  // --- DEFINE FORMATTER IF MISSING ---
  if (typeof Shopify === 'undefined') window.Shopify = {};

  if (typeof Shopify.formatMoney !== 'function') {
    Shopify.formatMoney = function (cents, format = '${{amount}}') {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      const amount = cents / 100;

      // Localised number (e.g. €10.00 or €10,00)
      const formattedNumber = amount.toLocaleString(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
      });

      // Shopify formats sometimes include {{amount}} but not the currency
      // → Remove symbol from our locale output if the format already includes it
      const hasSymbol = format.includes('€') || format.includes('£') || format.includes('$');
      const cleanNumber = hasSymbol
        ? formattedNumber.replace(/[€£$]\s?/, '')
        : formattedNumber;

      return format
        .replace(/\{\{\s*amount\s*\}\}/, cleanNumber)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(amount).toString())
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, cleanNumber.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(amount).toString().replace('.', ','))
        .replace('$', hasSymbol ? '' : currencySymbol);
    };
  }

  // --- BAR LOGIC ---
  const updateBar = (cart) => {
    const bar = document.querySelector('.custom-free-shipping-bar');
    if (!bar) return;

    const threshold = parseFloat(bar.dataset.threshold);
    const moneyFormat = bar.dataset.moneyFormat || Shopify.money_format || `${currencySymbol}{{amount}}`;
    const fill = bar.querySelector('.custom-free-shipping-fill');
    const message = bar.querySelector('.custom-free-shipping-message');

    const cartTotalWhole = cart.total_price / 100;
    const remainingWhole = Math.max(0, threshold - cartTotalWhole);
    const progress = Math.min(100, (cartTotalWhole / threshold) * 100);
    fill.style.width = `${progress}%`;

    if (remainingWhole > 0) {
      const remainingCents = Math.round(remainingWhole * 100);
      const formatted = Shopify.formatMoney(remainingCents, moneyFormat);
      message.textContent = `🎁 You're ${formatted} away from free shipping`;
      bar.classList.remove('unlocked');
    } else {
      message.textContent = `🎉 Free shipping unlocked!`;
      bar.classList.add('unlocked');
    }
  };

  // --- EVENT HANDLERS ---
  document.addEventListener('cart:updated', (event) => updateBar(event.detail.cart));

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateBar(cart);
    } catch (e) {
      console.error('CustomShippingBar init error', e);
    }
  });
})();
